/* eslint-disable lines-between-class-members,dot-notation */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { City } from "../City";
import { CustomerSettings } from "./CustomerSettings";
import { gender, genderTypes, pushNotificationTitles, pushNotificationTypes, pushTargetTitles, pushTargetTypes, pushTopicsTitles, pushTopicsTypes, roles, rolesTypes, statuses, statusesTypes } from "./statuses";
/**
 * Customer model
 */

export class Customer extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => this.model.id;

    this.getFirstName = () => this.model.firstName;

    this.getLastName = () => this.model.lastName;

    this.getMiddleName = () => this.model.middleName;

    this.getFullName = () => this.model.fullName;

    this.getCityId = () => this.model.cityId;

    this.getPassword = () => this.model.password;

    this.getBirthday = () => this.model.birthDay;

    this.getRole = (asLabel = false) => {
      return asLabel ? Customer.roles[this.model.role || 'unknown'] || Customer.roles['unknown'] : this.model.role;
    };

    this.getStatus = (asLabel = false) => {
      return asLabel ? Customer.statuses[this.model.status || 'unknown'] || Customer.statuses['unknown'] : this.model.status;
    };

    this.getGender = (asLabel = false) => {
      return asLabel ? Customer.gender[this.model.gender || 'unknown'] || Customer.gender['unknown'] : this.model.gender;
    };

    this.getSettings = settings => this.getRelation('Settings', CustomerSettings, settings);

    this.getCity = city => this.getRelation('city', City, city);

    this.getAttributes = () => {
      const {
        fullName,
        cityId,
        role,
        ...attributes
      } = this.model;
      return attributes;
    };
  }

  /**
   * Create customer
   *
   * @param {object} object
   *
   * @return {Customer}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list customers
   *
   * @param {object} objects
   *
   * @return {Array.<Customer>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map customers
   *
   * @param {Array.<object>} objects
   * @param {function(Customer): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get customer id
   *
   * @return {number}
   */


}
Customer.rolesTypes = rolesTypes;
Customer.roles = roles;
Customer.statusesTypes = statusesTypes;
Customer.statuses = statuses;
Customer.genderTypes = genderTypes;
Customer.gender = gender;
Customer.pushTargetTypes = pushTargetTypes;
Customer.pushTargetTitles = pushTargetTitles;
Customer.pushTopicsTypes = pushTopicsTypes;
Customer.pushTopicsTitles = pushTopicsTitles;
Customer.pushNotificationTypes = pushNotificationTypes;
Customer.pushNotificationTitles = pushNotificationTitles;